<template>
  <div class="market-trends">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'MarketTrends',
};
</script>
